import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationSidebarMosaic from '../../../_partials/DeviationSidebarMosaic';
import s from './DeviationMosaic.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

/** Sidebar block layout id 3 */
const DeviationMosaic: React.FC<React.PropsWithChildren<Props>> = ({
  block,
  deviation: parentDeviation,
}) => {
  return (
    <SidebarBlockWrapper deviation={parentDeviation} block={block}>
      <div className={s['root']}>
        <DeviationSidebarMosaic
          streamId={`sidebar-mosaic-${block.contentType}`}
          deviations={block.deviations ?? []}
          parentDeviation={parentDeviation}
        />
      </div>
    </SidebarBlockWrapper>
  );
};
DeviationMosaic.displayName = 'DeviationMosaic';

export default DeviationMosaic;
